<template id="swipe-wizzard">
  <f7-page class="main-newfarmerwizzard">
    <template #fixed>
      <TheNavbar
        :nav-title="`${!editFarmer ? 'Nuevo' : 'Editar'} Agricultor`"
        back-btn-enable
        :style="appTheme"
      />
    </template>

    <form @submit.prevent.stop="">
      <div class="swiper-container my-swiper">
        <div class="wizzard-header">
          <ul class="no-margin margin-bottom">
            <li
              v-for="item of totalSteps"
              :key="item"
            >
              <div
                class="wizzard-header__item"
                :class="{ 'wizzard-header__item--selected': item <= step }"
              >
                {{ item }}
              </div>
            </li>
          </ul>
        </div>
        <!-- Slides wrapper -->
        <div class="wizzard-body">
          <!-- <f7-block
            v-if="errors.length"
            class="wizzard-body__errors"
          >
            <div>Revise los errores en el formulario:</div>
            <ul>
              <li v-for="error in errors">
                {{ error }}
              </li>
            </ul>
          </f7-block> -->
          <!-- Slides -->
          <div
            v-show="step === 1"
            class="swiper-slide"
          >
            <div class="wizzard-body__title">
              Datos de contacto
            </div>
            <div>
              <f7-list>
                <!-- <f7-list-input
                  v-if="code !== ''"
                  :label="`${$t('common.code')}:`"
                  type="text"
                  :placeholder="`${$t('common.code')}:`"
                  readonly
                  clear-button
                  :value="code"
                  @input="code = $event.target.value"
                /> -->
                <f7-list-input
                  label="Nombre y apellidos"
                  type="text"
                  placeholder="Nombre y apellidos"
                  :required="stepValidations[1]"
                  :validate="stepValidations[1]"
                  clear-button
                  :value="name"
                  @input="name = $event.target.value"
                />

                <f7-list-input
                  label="DNI"
                  type="text"
                  placeholder="DNI"
                  :required="stepValidations[1]"
                  :validate="stepValidations[1]"
                  clear-button
                  :value="identifier"
                  @input="identifier = $event.target.value"
                />

                <f7-list-input
                  label="Email"
                  type="email"
                  placeholder="email"
                  :required="stepValidations[1]"
                  :validate="stepValidations[1]"
                  clear-button
                  :value="email"
                  @input="email = $event.target.value"
                />
                <li class="padding-horizontal padding-top-half">
                  <div class="item-title item-label">
                    {{ $t('common.issuingCountry') }}
                  </div>
                </li>
                <f7-list-item
                  :title="$t('common.issuingCountry')"
                  required
                  validate
                  smart-select
                  :smart-select-params="{
                    closeOnSelect: true,
                    searchbar: true,
                    virtualList: true,
                    setValueText: false,
                    cssClass: 'new-farmer-wizzard-smart-select',
                  }"
                  :after="selectableCountries.find((item) => item.id === country)?.name"
                >
                  <select
                    v-model="country"
                    name="emitCountry"
                  >
                    <option
                      v-for="(f) in selectableCountries"
                      :key="f.id"
                      :value="f.id"
                    >
                      {{ f.name }}
                    </option>
                  </select>
                </f7-list-item>

                <f7-list-input
                  label="Teléfono"
                  type="tel"
                  placeholder="Teléfono"
                  required
                  validate
                  clear-button
                  :value="phone"
                  @input="phone = $event.target.value"
                />
              </f7-list>
            </div>
          </div>
          <div
            v-show="step === 2"
            class="swiper-slide"
          >
            <div class="wizzard-body__title">
              Datos fiscales
            </div>
            <div>
              <f7-list>
                <f7-list-input
                  :label="$t('common.name')"
                  :placeholder="$t('common.name')"
                  type="text"
                  :required="stepValidations[2]"
                  :validate="stepValidations[2]"
                  :value="address.name"
                  @input="address.name = $event.target.value"
                />
                <f7-list-input
                  label="Tipo Vía"
                  type="select"
                  placeholder="Tipo Vía"
                  :required="stepValidations[2]"
                  :validate="stepValidations[2]"
                  clear-button
                  default-value="CL"
                  :value="address.type"
                  @change="address.type = $event.target.value"
                >
                  <option value="" />
                  <option
                    v-for="(value, key) in streetTypeOptions"
                    :key="key"
                    :value="key"
                  >
                    {{ value }}
                  </option>
                </f7-list-input>
                <f7-list-input
                  label="Nombre vía"
                  type="text"
                  placeholder="Nombre vía"
                  :required="stepValidations[2]"
                  :validate="stepValidations[2]"
                  clear-button
                  :value="address.name2"
                  @input="address.name2 = $event.target.value"
                />
                <li class="padding-horizontal padding-top-half">
                  <div class="item-title item-label">
                    {{ $t('common.country') }}
                  </div>
                </li>
                <f7-list-item
                  :label="$t('common.country')"
                  :title="$t('common.country')"
                  smart-select
                  :required="stepValidations[2]"
                  :validate="stepValidations[2]"
                  :smart-select-params="{
                    closeOnSelect: true,
                    searchbar: true,
                    virtualList: true,
                    setValueText: false,
                    cssClass: 'new-farmer-wizzard-smart-select',
                  }"
                  :after="selectableCountries.find((item) => item.id === address.country)?.name"
                >
                  <select
                    v-model="address.country"
                    name="addressCountry"
                  >
                    <option
                      v-for="(f) in selectableCountries"
                      :key="f.id"
                      :value="f.id"
                    >
                      {{ f.name }}
                    </option>
                  </select>
                </f7-list-item>
              </f7-list>
            </div>
          </div>
          <div
            v-show="step === 3"
            class="swiper-slide"
          >
            <div class="wizzard-body__title">
              Datos por empresa
            </div>
            <div>
              <f7-list>
                <f7-list-input
                  label="Empresa"
                  type="select"
                  placeholder="Empresa"
                  :required="stepValidations[3]"
                  :validate="stepValidations[3]"
                  clear-button
                  :value="BusinessData.business"
                  @change="BusinessData.business = $event.target.value; loadVATRate(BusinessData.business)"
                >
                  <option value="" />
                  <option
                    v-for="(value) in selectableBusiness"
                    :key="value.id"
                    :value="value.code"
                  >
                    {{ value.name }}
                  </option>
                </f7-list-input>
                <f7-list-input
                  label="Tipo de IVA"
                  type="select"
                  placeholder="Tipo de IVA"
                  :required="stepValidations[3]"
                  :validate="stepValidations[3]"
                  clear-button
                  :value="BusinessData.VATRate"
                  @change="BusinessData.VATRate = $event.target.value"
                >
                  <option value="" />
                  <option
                    v-for="(value) in selectableVATRate"
                    :key="value.id"
                    :value="value.code"
                  >
                    {{ value.name }}
                  </option>
                </f7-list-input>
                <f7-list-input
                  label="Retención"
                  type="select"
                  placeholder="Retención"
                  :required="stepValidations[3]"
                  :validate="stepValidations[3]"
                  clear-button
                  :value="BusinessData.retention"
                  @change="BusinessData.retention = $event.target.value"
                >
                  <option value="" />
                  <option
                    v-for="(value) in selectableRetention"
                    :key="value.id"
                    :value="value.code"
                  >
                    {{ value.name }}
                  </option>
                </f7-list-input>
              </f7-list>
            </div>
            <div class="wizzard-body__title padding-top">
              Pagos
            </div>
            <div>
              <f7-list>
                <f7-list-input
                  label="Forma de pago"
                  type="select"
                  placeholder="Forma de pago"
                  :required="stepValidations[3]"
                  :validate="stepValidations[3]"
                  clear-button
                  :value="BusinessData.wayToPay"
                  @change="BusinessData.wayToPay = $event.target.value"
                >
                  <option value="" />
                  <option
                    v-for="(value) in selectableWayToPay"
                    :key="value.id"
                    :value="value.code"
                  >
                    {{ value.name }}
                  </option>
                </f7-list-input>
              </f7-list>
            </div>
          </div>
          <div
            v-show="step === 4"
            class="swiper-slide"
          >
            <div class="wizzard-body__title">
              Más información
            </div>
            <div>
              <f7-list>
                <ComplementaryData
                  :entity="8"
                  :dcs-data="dcData"
                  @data-changed="complementaryDataChanged"
                />
              </f7-list>
            </div>
          </div>
        </div>
        <!-- Pagination, if required -->
        <div class="swiper-pagination" />
      </div>
      <f7-block>
        <f7-row>
          <f7-col v-if="step !== 1">
            <f7-button
              fill
              class="button-prev mySwiper"
              @click="prevStep"
            >
              Anterior
            </f7-button>
          </f7-col>
          <f7-col v-if="step !== totalSteps">
            <f7-button
              fill
              type="submit"
              class="button-next mySwiper"
              @click="nextStep"
            >
              Siguiente
            </f7-button>
          </f7-col>
          <f7-col v-if="step === totalSteps">
            <f7-button
              v-if="!editFarmer"
              fill
              type="submit"
              @click="sendEnquiry"
            >
              {{ $t('common.save') }}
            </f7-button>
            <f7-button
              v-else
              fill
              type="submit"
              @click="sendEnquiry"
            >
              {{ $t('common.edit') }}
            </f7-button>
          </f7-col>
        </f7-row>
      </f7-block>
    </form>
  </f7-page>
</template>

<script>
import { nextTick } from 'vue';
import MasterDataService from '@/js/services/contracts/MasterData';
import ComplementaryData from '@/components/contracts/ComplementaryData.vue';
import FarmerService from '@/js/services/contracts/Farmers';
import { StreetType } from '@/js/enums/erp';
import { LogError } from '@/js/common/HIDebuggingSupport';
import { f7 } from 'framework7-vue';
import TheNavbar from '@/components/TheNavbar.vue';

export default {
  name: 'NewFarmerWizzardPage',
  components: {
    TheNavbar,
    ComplementaryData,
  },
  props: {
    farmerEdit: { type: Object, default: null, require: false },
    editFarmer: { type: Boolean, default: false, require: false },
  },
  data() {
    return {
      step: 1,
      totalSteps: 4,
      errors: [],
      IdFarmer: 0,
      code: '',
      country: '',
      name: '',
      identifier: '',
      phone: '',
      email: '',
      address: {
        name: '',
        name2: '',
        type: '',
        country: '',
      },
      BusinessData: {
        retention: '',
        business: '',
        wayToPay: '',
        VATRate: '',
      },
      dcData: {},
      selectableCountries: [],
      selectableVATRate: [],
      selectableRetention: [],
      selectableBusiness: [],
      selectableWayToPay: [],
      validateSecond: false,
      stepValidations: {
        1: true,
        2: false,
        3: false,
        4: false,
      },
    };
  },
  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    newFarmer() {
      return {
        id: this.IdFarmer,
        name: this.name,
        identifier: this.identifier,
        phone: this.phone,
        email: this.email,
        country: this.country,
        code: this.code,
        address: this.address,
        CompanyProvider: this.BusinessData,
        dcs: this.dcData,
      };
    },
    streetTypeOptions() {
      return StreetType;
    },
  },
  async mounted() {
    await this.loadCountries();
    await this.loadRetention();
    await this.loadBusiness();

    await this.loadWayToPay();
    if (this.editFarmer) {
      await this.AssignEditValues();
    }
    if (this.BusinessData.business !== '') {
      await this.loadVATRate(this.BusinessData.business);
    }

    nextTick(() => {
      if (this.farmerEdit != null && this.farmerEdit.country != null && this.farmerEdit.country !== undefined) {
        this.country = this.farmerEdit.country;
      } else {
        this.country = 'ES';
      }
      if (this.farmerEdit != null && this.farmerEdit.address.country != null && this.farmerEdit.address.country !== undefined) {
        this.address.country = this.farmerEdit.address.country;
      } else {
        this.address.country = 'ES';
      }
    });
  },
  methods: {
    nextStep() {
      this.stepValidations[this.step] = true;

      if (this.step === 1) {
        this.errors = [];

        if (!this.name) {
          this.errors.push('El nombre es obligatorio.');
        }
        if (!this.identifier) {
          this.errors.push('El DNI es obligatorio.');
        }
        if (!this.name || !this.identifier) {
          f7.dialog.create({
            title: 'Revise los errores',
            text: this.errors.join('<br>'),
            buttons: [
              {
                text: this.$t('common.accept'),
              },
            ],
            verticalButtons: true,
          }).open();
          return false;
        }
      }
      if (this.step === 2) {
        this.validateSecond = true;
        this.errors = [];

        if (!this.address.name) {
          this.errors.push('La dirección es obligatoria');
        }
        if (!this.address.type) {
          this.errors.push('El tipo de vía es obligatoria');
        }
        if (!this.address.name2) {
          this.errors.push('La dirección es obligatoria');
        }
        if (!this.address.country) {
          this.errors.push('Debe seleccionar un país');
        }
        if (!this.address.name || !this.address.type
          || !this.address.country || !this.address.name2) {
          f7.dialog.create({
            title: 'Revise los errores',
            text: this.errors.join('<br>'),
            buttons: [
              {
                text: this.$t('common.accept'),
              },
            ],
            verticalButtons: true,
          }).open();
          return false;
        }
      }
      if (this.step === 3) {
        this.validateSecond = true;
        this.errors = [];

        if (!this.BusinessData.business) {
          this.errors.push('La Empresa es obligatoria');
        }

        if (!this.BusinessData.business) {
          f7.dialog.create({
            title: 'Revise los errores',
            text: this.errors.join('<br>'),
            buttons: [
              {
                text: this.$t('common.accept'),
              },
            ],
            verticalButtons: true,
          }).open();
          return false;
        }
      }

      this.step += 1;

      return true;
    },
    prevStep() {
      this.errors = [];
      this.stepValidations[this.step] = false;
      this.step -= 1;
    },
    sendEnquiry() {
      if (this.step === 4) {
        this.addNewFarmer();
      }
    },
    async addNewFarmer() {
      try {
        if (this.editFarmer) {
          this.newFarmer.sync_status = 1;
          await FarmerService.updateById(this.newFarmer.id, this.newFarmer);
        } else {
          delete this.newFarmer.id;
          await FarmerService.add(this.newFarmer);
        }

        f7.views.main.router.back('/commercialisation/contracts/frmContracts', { ignoreCache: true, force: true });
      } catch (e) {
        LogError(this, this.addNewFarmer.name, e);
      }
    },
    complementaryDataChanged(newValue) {
      this.dcData = newValue;
    },
    async loadCountries() {
      const countries = await MasterDataService.getAllCountries();
      this.selectableCountries = countries;
    },

    async loadVATRate(business) {
      const VATRate = await MasterDataService.getAllVATRate();
      const tempbusiness = this.selectableBusiness.filter((f) => f.code === business);
      this.selectableVATRate = VATRate.filter((f) => f.business === tempbusiness[0].id);
    },
    async loadRetention() {
      const retention = await MasterDataService.getAllRetention();
      this.selectableRetention = retention;
    },
    async loadBusiness() {
      const business = await MasterDataService.getAllBusiness();
      this.selectableBusiness = business;
    },
    async loadWayToPay() {
      const wayToPay = await MasterDataService.getAllWayToPay();
      this.selectableWayToPay = wayToPay;
    },
    AssignEditValues() {
      this.IdFarmer = this.farmerEdit.id;
      this.country = this.farmerEdit.country;
      this.name = this.farmerEdit.name;
      this.identifier = this.farmerEdit.identifier;
      this.phone = this.farmerEdit.phone;
      this.email = this.farmerEdit.email;
      this.address = this.farmerEdit.address;
      this.dcData = this.farmerEdit.dcs;
      this.code = this.farmerEdit.code;
      if (this.farmerEdit.CompanyProvider != null) {
        this.BusinessData = this.farmerEdit.CompanyProvider;
      }

      nextTick(() => {
        this.country = this.farmerEdit.country;
        this.address.country = this.farmerEdit.address.country;
      });
    },

  },
};
</script>

<style lang="scss">
.main-newfarmerwizzard {
  --available-viewport-height: calc(100vh - var(--information-bar-height));

  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="month"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  .smart-select .item-content .item-inner,
  textarea {
    border: 1px solid var(--his-silver);
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
  }

  .item-content {
    .item-inner {
      margin-top: 20px;

      .item-input-wrap {
        input {
          height: 50px;
          padding-left: 10px;
        }

        .input-clear-button {
          margin-top: -4px;
          margin-right: 15px;
        }
      }
    }
  }

  .page-content {
    background: var(--his-whispering-lilac);
  }

  .wizzard-header {
    padding-top: 1px;
    background: linear-gradient(0deg, #fff 50%, var(--his-dark-blue) 50%);

    ul {
      display: flex;
      justify-content: space-evenly;
      list-style: none;
    }

    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: var(--his-oliva);
      width: 50px;
      height: 50px;
      border-radius: 50%;

      &--selected {
        background-color: var(--his-greenlight);
      }
    }
  }

  .wizzard-body {
    &__errors {
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      margin-bottom: 0;

      div {
        font-size: 14px;
        color: var(--f7-input-error-text-color);
        font-weight: bold;
      }

      ul {
        list-style: inside;
        margin-top: 5px;

        li {
          font-size: 14px;
          color: var(--f7-input-error-text-color);
        }
      }
    }

    &__title {
      border-bottom: 1px solid var(--his-disabled);
      padding-left: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-left));
      color: var(--his-ash-gray);
      font-size: 14px;
      font-weight: 400;
      text-transform: uppercase;
      padding-bottom: 6px;
    }

    .list {
      padding-top: 15px;

      .list {
        padding: 0;
      }
    }
  }

  .my-swiper {
    margin: 0 0 35px;
    font-size: 18px;
    height: calc(var(--available-viewport-height) - 154px);
    overflow-y: scroll;
  }

  .button-next {
    background-color: var(--his-mandarina);
  }
}

.new-farmer-wizzard-smart-select {
  --f7-navbar-bg-color: var(--his-dark-blue);
}
</style>
